import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-slider-wrapper',
  templateUrl: './slider-wrapper.component.html',
  styleUrl: './slider-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule]
})
export class FormlySliderWrapperComponent extends FieldWrapper {

}
